import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const uploadThemeToken: any = {
  //======================== COLOR =================================/
  colorText: variableColors["ColorFigmaNeutralGrayscaleGray90"],
  colorBorder: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorFillAlter: variableColors["ColorFigmaNeutralGrayscaleGray10"],
  colorPrimary: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryBorder: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimaryHover: variableColors["ColorFigmaComplementaryBlue50"],

  //========================= FONT =================================/
  fontHeight: variableTypography["BodyMediumLineHeight"],
  fontSize: variableTypography["BodyMediumFontSize"],

  //========================= SIZE =================================/
  controlHeightLG: 60,
};
